import React from 'react';

import StatusCell from '../../../components/Badge/StatusCell';
import InfoGrayIcon from '../../../components/Icons/InfoGrayIcon';
import RedExitIcon from '../../../components/Icons/RedExitIcon';
import ExitDispatcherModal from '../../../components/Modal/ModalActions/ExitDispatcherModal/ExitDispatcherModal';
import ReportIssueModal from '../../../components/Modal/ModalActions/ReportIssueModal/ReportIssueModal';
import Table from '../../../components/Table/Table';
import ActionRowWithModal from '../../../components/Table/TableAccessories/ActionRowWithModal';
import TableDateTimeFormatter from '../../../components/Table/TableAccessories/TableDateTimeFormatter';
import TableNameCapitalizeFormatter from '../../../components/Table/TableAccessories/TableNameCapitalizeFormatter';
import TablePhoneFormatter from '../../../components/Table/TableAccessories/TablePhoneFormatter';
import ReceivedConflictRowCell from '../../../components/Table/TableMobileRowCell/ReceivedConflictRowCell';

const ReceivedConflictsList = () => {
  return (
    <>
      <Table
        // border
        // tableTitle='Incident Reports'
        // hasClickableRow
        // clickRowAction={(rowData: any) => {
        //   return navigate(`/${DRIVER_PERFORMANCE_REPORT}`, {
        //     state: { data: rowData },
        //   });
        // }}
        tableFilterBoxFeatures={{
          showSearchBox: true,
          searchBoxPlaceholder: 'Search driver name...',
        }}
        tableHeader={{
          Date: 'createdAt',
          'Driver Name': 'driverName',
          'Conflict Company': 'hiringCompanyName',
        }}
        tableDataSourceUrl={`api/v1/company/hiring-conflicts`}
        cellsCustomComp={{
          createdAt: <TableDateTimeFormatter dataKey='createdAt' />,
          status: <StatusCell statusKey='status' />,
          phoneNumber: <TablePhoneFormatter dataKey='phoneNumber' />,
          name: <TableNameCapitalizeFormatter dataKey='name' />,
        }}
        moreOptionsComponents={[
          <ActionRowWithModal
            key='Report Issue'
            label='Report Issue'
            width='257px'
            icon={<InfoGrayIcon />}
            modalCompFn={(data) => <ReportIssueModal data={data} />}
          />,

          <ActionRowWithModal
            key='Exit Driver'
            label='Exit Driver'
            width='257px'
            color='#D20832'
            icon={<RedExitIcon />}
            modalCompFn={(data) => <ExitDispatcherModal data={data} />}
          />,
        ]}
        mobileCellComp={<ReceivedConflictRowCell />}
        // showPaginationControl={false}
      />
    </>
  );
};

export default ReceivedConflictsList;
